<script>
import Label from './Label.vue'

export default {
    props: {
        item_key: {
        type: String,
        required: true,
        },
        item_value: {
        // type: Object || String,
        required: false,
        },
        item: {
        type: Object,
        required: true,
        },
        submitted: {
        type: Boolean,
        required: true,
        },
        validation: {
        type: Object,
        required: true,
        },
        updateValue: {
            type: Function,
            required: true
        }
    },
    components: {
        Label
    },
    data() {
        return {
            value: this.item_value,
        };
    },
    watch: {
        item_value: {
            handler(val) {
                if(this.value != val) this.value = val;
            },
            deep: true
        },
        value(val) { 
            this.updateValue(this.item_key, val);
        },
    },
};
</script>
<template>
    <div class="mb-3">
        <Label :item="item"/>
        <div class="row col-12">
            <div v-for="option in value" v-bind:key="option.name" class="form-check col-4">
                <input class="form-check-input" type="checkbox" v-model="option.value">
                <label class="form-check-label">{{option.name}}</label>
            </div>
        </div>

        <div v-if="submitted && validation.$error" class="invalid-feedback">
        <span v-if="!validation.required">This value is required.</span>
        </div>
    </div>
</template>



